import { render, staticRenderFns } from "./WarehouseViewWarehouseProducts.vue?vue&type=template&id=4428aaa8&"
import script from "./WarehouseViewWarehouseProducts.vue?vue&type=script&lang=js&"
export * from "./WarehouseViewWarehouseProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports